import React, { useEffect, useState } from "react";
import EditTagModal from "./EditTagModal";
import { useUser } from "../../context/UserContext";
import { fetchWithAuth } from '../../utils/fetchWithAuth';
import Button from '../UI/Button';

const NfcTagTable = () => {
    const [tags, setTags] = useState([]);
    const [search, setSearch] = useState("");
    const [typeFilter, setTypeFilter] = useState("");
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [total, setTotal] = useState(0);
    const [selectedTag, setSelectedTag] = useState(null);
    const { logout, hasPermission } = useUser();


	const canDelete = hasPermission("nfc", "delete");
    const canEdit = hasPermission("nfc", "edit");

    const fetchTags = async () => {
        try {
            const params = new URLSearchParams({
                search,
                type: typeFilter,
                page,
                limit,
            });
            const res = await fetchWithAuth(
                `${process.env.REACT_APP_API_URL}/nfc-checkpoints?${params.toString()}`,
                {},
                logout
            );
            const data = await res.json();

            setTags(data.data || []);
            setTotal(data.total || 0);
        } catch (err) {
            console.error("Ошибка при загрузке меток:", err);
        }
    };

    useEffect(() => {
        fetchTags();
    }, [search, typeFilter, page]);

    const handleEditClick = (tag) => setSelectedTag(tag);

    const handleDelete = async (id) => {
        if (!window.confirm("Удалить эту метку?")) return;

        try {
            const res = await fetchWithAuth(
                `${process.env.REACT_APP_API_URL}/nfc-checkpoints/${id}`,
                {
                    method: "DELETE",
                },
                logout
            );
            if (!res.ok) throw new Error("Ошибка удаления");
            fetchTags();
        } catch (err) {
            console.error("Ошибка при удалении:", err);
            alert("Ошибка при удалении метки");
        }
    };

    const totalPages = Math.ceil(total / limit);

    return (
        <div className="p-6 bg-[#252526] text-[#CCCCCC] border border-[#3E3E42] rounded-lg shadow max-w-7xl mx-auto">
            <h2 className="text-2xl font-semibold mb-6">Список NFC меток</h2>

            <div className="flex flex-wrap gap-4 mb-6">
                <input
                    type="text"
                    placeholder="Поиск по имени/описанию"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="bg-[#1E1E1E] border border-[#555] text-white p-2 rounded w-full sm:w-64"
                />

                <select
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                    className="bg-[#1E1E1E] border border-[#555] text-white p-2 rounded w-full sm:w-40"
                >
                    <option value="">Все типы</option>
                    <option value="entry">Вход</option>
                    <option value="exit">Выход</option>
                </select>
            </div>

            <div className="overflow-x-auto">
                <table className="w-full border border-[#3E3E42] text-sm rounded overflow-hidden">
                    <thead className="bg-[#2D2D30] text-[#CCCCCC]">
                        <tr>
                            <th className="p-3 border-b border-[#3E3E42] text-left">Название</th>
                            <th className="p-3 border-b border-[#3E3E42] text-left">Тип</th>
                            <th className="p-3 border-b border-[#3E3E42] text-left">Локация</th>
                            <th className="p-3 border-b border-[#3E3E42] text-left">Описание</th>
                            <th className="p-3 border-b border-[#3E3E42] text-left">Действия</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tags.map((tag) => (
                            <tr key={tag._id} className="hover:bg-[#2D2D30] transition">
                                <td className="p-3 border-b border-[#3E3E42]">{tag.name}</td>
                                <td className="p-3 border-b border-[#3E3E42]">
                                    {tag.type === "entry" ? "Вход" : "Выход"}
                                </td>
                                <td className="p-3 border-b border-[#3E3E42]">{tag.location}</td>
                                <td className="p-3 border-b border-[#3E3E42]">{tag.description}</td>
                                <td className="p-3 border-b border-[#3E3E42] space-x-2">
                                    {canEdit && <Button
                                        onClick={() => handleEditClick(tag)}
                                        variant="edit"
                                    >
                                        Редактировать
                                    </Button>}
                                    {canDelete && (
                                        <Button
                                            onClick={() => handleDelete(tag._id)}
                                            variant="danger"
                                        >
                                            Удалить
                                        </Button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="mt-4 flex gap-2">
                {Array.from({ length: totalPages }, (_, i) => (
                    <Button
                        key={i}
                        onClick={() => setPage(i + 1)}
                        variant="pagination"
                        className={page === i + 1 ? "bg-[#3E3E42] text-white" : ""}
                    >
                        {i + 1}
                    </Button>
                ))}
            </div>

            {selectedTag && (
                <EditTagModal
                    tag={selectedTag}
                    onClose={() => setSelectedTag(null)}
                    onUpdate={fetchTags}
                />
            )}
        </div>
    );
};

export default NfcTagTable;
